<template>
  <div class="m-snippet">
    <div class="g">
      <div class="g__col g__col-12">
        <div class="g align-v-center">
          <div class="g__col">
            <div class="u-trim-pad">
              <span class="meta meta--tight">{{ hit.CourseAwardName }}</span>
            </div>
          </div>
        </div>
        <a :href="hit.CourseUrl" class="m-snippet__link">
          <h3 class="h2 m-snippet__heading">{{ hit.CourseTitle }}</h3>
        </a>
        <div class="mg-bottom--half">
          <span class="pill">{{ hit.CourseType }}</span
          >&nbsp; <span class="pill pill--secondary">{{ hit.ModeOfAttendance }}</span
          >&nbsp; <span class="pill pill--secondary">{{ hit.StudyLength }}</span
          >&nbsp;
          <!-- <span v-if="hit.UcasPoints" class="pill pill--secondary">{{ hit.UcasPoints }}</span> -->
        </div>

        <p v-if="!isMobile" class="mg-bottom">{{ hit.CourseSummary | stripHtml | widont }}</p>
        <div v-if="showSubject" class="mg-bottom">
          <subject-area-pill :subject="hit.Subject" />
        </div>
      </div>
    </div>

    <div class="g">
      <div class="g__col g__col-12 g__col-6@large">
        <span class="meta meta--tight meta--grey">
          {{ hit.YearOfEntry }}
          <template v-if="hit.UcasCode"> | UCAS: {{ hit.UcasCode }} </template>
        </span>
      </div>

      <div class="g__col g__col-12 g__col-6@large u-text-right@large">
        <template v-if="hit.NoLongerRecruiting">
          <span class="meta meta--tight">
            <span class="status-indicator status-indicator--red"></span>
            {{ uiLabels.NO_LONGER_RECRUITING }}
          </span>
        </template>
        <template v-else-if="enableClearing && hit.IsInClearing">
          <span class="meta meta--tight">
            <span class="status-indicator status-indicator--green"></span>
            {{ uiLabels.COURSE_IN_CLEARING }}
          </span>
        </template>
      </div>
    </div>
    <hr v-if="!isDesktop" class="hr--small" />
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";

import trackingHelper from "@/js/search/mixins/trackingHelper";

import SubjectAreaPill from "@/js/search/components/results/SubjectAreaPill";

export default {
  components: {
    SubjectAreaPill,
  },
  filters: {
    widont: (str) => (str ? str.replace(/\s([^\s]+)\s*$/, "\u00A0$1") : str),
    stripHtml: (str) => (str ? str.replace(/(<([^>]+)>)/gi, "") : str),
  },
  mixins: [trackingHelper],
  props: {
    hit: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters(["isMobile", "isDesktop"]),
    ...mapState({
      uiLabels: ({ search }) => search.uiLabels,
      dictionary: ({ search }) => search.solrDictionary,
      showSubject: ({ search }) => !search.enforcedSubjectArea,
      enableClearing: ({ ui }) =>
        ui.config.CLEARING ? ui.config.CLEARING.SHOW_UI || ui.config.CLEARING.ENFORCED : false,
    }),
  },
};
</script>
